export interface IGameCopper {
    id: string
    name: string
    subtitle: string[]
    desc: string
    type: "good" | "bad" | "normal"
    text: {
        good: string
        bad: string
        career: string
        wealth: string
        emotion: string
    }
}

export interface IRelicGroup {
    name: string
    items: IRelic[]
}

export interface IRelic {
    id: string
    orderId: string
    name: string
    usage: string
    desc: string
}

export interface IGameResult {
    id: string
    title: string
    description: string
    special?: boolean
    awardId: string
}

import React, { useCallback } from "react"
import { create } from "zustand"

interface I18nObjects {
    gameCopper: Record<string, IGameCopper>
    gameResult: Record<string, IGameResult>
    relicGroups: IRelicGroup[]
    relicDict: Record<string, IRelic>
    gameRandomDict: {
        band: string[]
        recruitGroups: string[]
        relics: string[]
    }
    resultRhodes: Record<
        string,
        { good: string | string[]; bad: string | string[] }
    >
    enemyList: {
        id: string
        name: string
        desc: string
        dangerLevel: string
    }[]
}

export interface TopicI18nStore {
    LoginView: React.FC<{ className?: string; style?: React.CSSProperties }>

    objects: I18nObjects
}

export const useTopicI18nStore = create<TopicI18nStore>(() => ({
    LoginView: () => <></>,
    objects: {
        gameCopper: {},
        gameResult: {},
        relicGroups: [],
        relicDict: {},
        gameRandomDict: {
            band: [],
            recruitGroups: [],
            relics: [],
        },
        resultRhodes: {},
        enemyList: [],
    },
}))

export const useTranslationObjects = () => {
    const objects = useTopicI18nStore((state) => state.objects)
    const t = useCallback(
        (key: keyof I18nObjects) => {
            return objects?.[key]
        },
        [objects]
    )
    return { t, dict: objects! as I18nObjects }
}
